<template>
    <div>
      <div ref="map1" style="height:330px;background-color:#eee;position:relative;top:0;z-index:100;"></div>

      <span v-if="selectedLayer" style="font-size:0.9em;"><strong>Selected:</strong> {{ selectedLayer['title'] }}</span>      

      <div style="width:100%;position:relative;height:60px;border:0px solid green;overflow:hidden;">

      <table class="table-sm" style="width:0%;height:60px;position:absolute;right:0px;border:0px solid orange;">
        <tr>
          
          <td v-for="year in [2018, 2019, 2020, 2021, 2022, 2023, 2024]" style="border-left:1px dotted #666;padding-left:3px;padding-right:3px;width:0%;">
            {{year}}<br/>
            <div style="background-color:#eee;width:0%;">
            <nobr>
            <a class="layer-link" href="" @click.prevent="selectedLayer=layer" v-for="layer in layersByYear[year]" :style="styleForLayer(layer)">            &nbsp;
              
            </a>
            </nobr>
            </div>
          </td>
        </tr>
      </table>
      
      </div>

  </div>



</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import _ from 'lodash';

import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";

export default {
    name: 'RasterMapExplore',
    components: { },
    props: ['contextlocation', 'sidebar', 'factsheet'],
    data() {
      return {
        layers: [],
        map1: null,
        extent: null,
        selectedLayer: null
      };
    },
    computed: {
      numCols() {
      },
      numRows() {
      },
    },
    mounted() {
      
    },
    created() {
      var url = process.env.VUE_APP_API+'/api/layers';
        this.$axios.get(url)
          .then(response => {


              var layers = []
              for (var i=0; i<response.data["results"].length; i++) {
                var layer = response.data["results"][i]
                layer["dateObj"] = Date.parse(layer["date"])

                console.log("country: "+this.factsheet["info"]["location"]["country"])
                console.log("res: "+layer['resolution'])
                if((this.factsheet["info"]["location"]["country"] == 'jo') && (layer['resolution'] == 5)) {
                  //skip
                  console.log("skip")
                } else {
                  layers.push(layer);
                  console.log("add")
                }
                
              }
              this.layers = layers
              this.initMap1()
              this.selectedLayer = this.layers.slice(-1)[0]
          })
    },
    watch: {
      sidebar() {
        this.updateView()
      },
      contextlocation() {
      },
      selectedLayer() {
        if(this.selectedLayer != null) {
          var url = this.urlForLayer(this.selectedLayer)
          this.map1DataLayer.setUrl(url)          
        }

      }
    },
    methods: {
      urlForLayer(layer) {
        if (layer["query_params"] != null) {
          var query_string = new URLSearchParams(layer["query_params"]).toString()
          return layer["url"]+'?'+query_string;
        } else {
          return layer["url"];
        }
      },
      styleForLayer(layer) {
        var color = "#ddd"
        var width = 1
        if(layer.resolution <= 5) {
          color = "#31a354"
        }
        else if(layer.resolution <= 10) {
          color = "#a1d99b"
        } else {
          color = "#e5f5e0"
        }
        if( (this.selectedLayer) && (layer["id"] == this.selectedLayer["id"]) ) {
          color = 'yellow'
          width = 1
        }
        if(color != 'yellow') {
          return "background-color:"+color+";border:"+width+"px solid "+color+";"
        } else {
          return "background-color:"+color+";border:"+width+"px solid #444;";
        }
      },
      initMap1() {
        if(!this.map1) {
          this.map1 = L.map(this.$refs.map1, { 
            'attributionControl': false, 
            'scrollWheelZoom': false,
            'zoomControl': false }
          )
          L.control.scale().addTo(this.map1);
          //this.map1.createPane('backgrounds');
          //this.map1.getPane('backgrounds').style.zIndex = 100;
          this.map1.createPane('data');
          this.map1.getPane('data').style.zIndex = 200;
          //this.map1Layer = L.tileLayer("", {'pane':'backgrounds'}).addTo(this.map1);
          this.map1DataLayer = L.tileLayer("", {'pane':'data', 'opacity': 100}).addTo(this.map1);


          this.map1.on('moveend', (e) => {
            this.extent = this.map1.getBounds();
            this.$emit('set-explore-extent', this.extent)
          });
          this.map1.on('zoomend', (e) => {
            this.extent = this.map1.getBounds()
            this.$emit('set-explore-extent', this.extent)
          });

          this.map1DataLayer.setUrl(process.env.VUE_APP_API+"/tools/layer/OpenStreetMap/v1?z={z}&x={x}&y={y}")


          if(this.sidebar) {
            this.updateView()
          }
          console.log("Done!")
        }
      },
      updateView() {
        this.map1.setView(this.sidebar.location, this.sidebar.zoom + 3)
      }
    },
    computed: {
      layersByYear() {
        var layers = {}

        _.forEach(this.layers, (layer) => {
          var year = layer["date"].substr(0,4);
          if(!layers.hasOwnProperty(year)) {
            layers[year] = [];
          }
          layers[year].push(layer);
        });
        return layers;
      }
    }
  }
</script>

<style scoped>
td {
  padding:3px 0px;;
}
a.layer-link {
  width:7px;
  height:20px;
  display:inline-block;;
  margin:0px 1px;
  background-color:#ccc;
}
a.layer-link:hover {
  background-color:#007bff;
}
</style>